// extracted by mini-css-extract-plugin
export default {"container":"CartCard_container__Qpb-m","bookInfo":"CartCard_bookInfo__UGNYi"};